import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

export interface List {
  title: string;
  icon: string;
  url: string;
}

@Component({
  selector: 'p8-bdc-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  opened = true;
  sidenavMode = 'side';
  title = '';

  constructor(private activatedRoute: ActivatedRoute) { }
  lists: List[] = [
    {
      title: 'Pages',
      icon: 'description',
      url: 'pages/'
    },
    {
      title: 'Images',
      icon: 'collections',
      url: 'images/'
    },
    {
      title: 'Documents',
      icon: 'library_books',
      url: 'documents/'
    },
    {
      title: 'Commentaires',
      icon: 'question_answer',
      url: 'comments/'
    },
    {
      title: 'Messages',
      icon: 'feedback',
      url: 'feedbacks/'
    }
  ];

  ngOnInit() {

    //  Not necessaire

    // this.activatedRoute.data.subscribe(data => {
    //   if ('title' in data)
    //     this.title = data.title;
    // })
  }

}
